import React from 'react';
import { PearlLogo } from '../PearlLogo';
import { Navigation } from '../Navigation';

import './landingPageContainer.scss';

const copyRightText = "The Pearl © 2025";
const disclaimerText = "Our app provides educational and informational content only. It is not intended to be a substitute for consultation, diagnosis, treatment or other professional medical advice from a healthcare professional, nor is it designed to provide you with a medical diagnosis, treatment or other medical services.";

export const LandingPageContainer = ({
    showLogo = true,
    showDisclaimerText = false,
    children
}) => {
    // Extract h1, h2, p.landing-page__hero-intro, and p.landing-page__hero-provocative from hero-content div if they exist
    let heroTitle = null;
    let heroSubtitle = null;
    let heroProvocative = null;
    let heroIntro = null;
    let remainingChildren = children;
    
    // Handle children as array or single element
    const childrenArray = React.Children.toArray(children);
    const heroContentIndex = childrenArray.findIndex(child => 
        React.isValidElement(child) && 
        child.props?.className?.includes('landing-page__hero-content')
    );
    
    if (heroContentIndex !== -1) {
        const heroContentDiv = childrenArray[heroContentIndex];
        const heroContentChildren = React.Children.toArray(heroContentDiv.props.children);
        
        // Find h1, h2, p.landing-page__hero-intro, and p.landing-page__hero-provocative
        heroTitle = heroContentChildren.find(child => 
            React.isValidElement(child) && child.type === 'h1'
        );
        heroSubtitle = heroContentChildren.find(child => 
            React.isValidElement(child) && child.type === 'h2'
        );
        heroProvocative = heroContentChildren.find(child => 
            React.isValidElement(child) && 
            child.type === 'p' && 
            child.props?.className === 'landing-page__hero-provocative'
        );
        heroIntro = heroContentChildren.find(child => 
            React.isValidElement(child) && 
            child.type === 'p' && 
            child.props?.className === 'landing-page__hero-intro'
        );
        
        // Create new hero-content div without h1, h2, and p elements
        const filteredHeroContent = heroContentChildren.filter(child => 
            !(React.isValidElement(child) && 
              ((child.type === 'h1') || 
               (child.type === 'h2') ||
               (child.type === 'p' && child.props?.className === 'landing-page__hero-intro') ||
               (child.type === 'p' && child.props?.className === 'landing-page__hero-provocative')))
        );
        
        const updatedHeroContent = React.cloneElement(heroContentDiv, {
            children: filteredHeroContent
        });
        
        // Replace the hero-content div in children array
        const newChildrenArray = [...childrenArray];
        newChildrenArray[heroContentIndex] = updatedHeroContent;
        remainingChildren = newChildrenArray;
    }
    
    return (
    <div className="landing-page">
        <Navigation />
        <main className="landing-page__main">
            <h2 className="landing-page__site-title">The Pearl</h2>
            <p className="landing-page__site-subtitle">AI Alignment Research Lab</p>
            {heroTitle}
            {heroSubtitle}
            {heroProvocative}
            {heroIntro}
            <div className="landing-page__hero">
                {showLogo && <PearlLogo className="landing-page__pearl-logo"/>}
                {remainingChildren}
            </div>
        </main>
        <footer className="landing-page__footer">
          {showDisclaimerText && (
            <div className="landing-page__disclaimer">
                {disclaimerText}
            </div>
          )}
          <div className="landing-page__footer-content">
            <span className="landing-page__copyright">{copyRightText}</span>
            <div className="landing-page__footer-links">
              <a href="#crisis" onClick={(e) => {
                e.preventDefault();
                const target = document.querySelector('#crisis');
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}>Research</a>
              <a href="#product" onClick={(e) => {
                e.preventDefault();
                const target = document.querySelector('#product');
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}>Contact</a>
            </div>
          </div>
        </footer>
      </div>
    );
};
